var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentsAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 28.7501C52.5086 32.0497 51.7377 35.3048 50.25 38.2501C48.4861 41.7794 45.7744 44.748 42.4186 46.8233C39.0629 48.8985 35.1956 49.9985 31.25 50.0001C27.9503 50.0087 24.6953 49.2377 21.75 47.7501L7.5 52.5001L12.25 38.2501C10.7623 35.3048 9.9914 32.0497 10 28.7501C10.0015 24.8045 11.1015 20.9372 13.1768 17.5814C15.2521 14.2257 18.2206 11.514 21.75 9.75007C24.6953 8.2624 27.9503 7.49147 31.25 7.50007H32.5C37.7109 7.78755 42.6326 9.98697 46.3229 13.6772C50.0131 17.3675 52.2125 22.2892 52.5 27.5001V28.7501Z",
    stroke: "#D96525",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsAdmin);
export default __webpack_public_path__ + "static/media/comments-admin.d38ef6461dc648a8fd18fbe5723f2ce3.svg";
export { ForwardRef as ReactComponent };